import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ENDPOINTS } from '@shared/constants';
import {
  CommonResponseDTO,
  IApiKey,
  IPublicKeyResponse,
} from '@shared/interfaces';
import { generateURL } from '@shared/utils';

@Injectable({
  providedIn: 'root',
})
export class MapsKeysService {
  constructor(private http: HttpClient) {}

  generatePublicApiKey(
    mapId: string
  ): Observable<CommonResponseDTO<IPublicKeyResponse>> {
    const url = generateURL({
      endpoint: ENDPOINTS.MAPS_DATA_POINTS_GENERATE_PUBLIC_API_KEY,
      params: { id: mapId },
    });
    return this.http.get<CommonResponseDTO<IPublicKeyResponse>>(url);
  }

  saveGeneratedPublicApiKey(
    mapId: string,
    apiKey: string,
    reference: string
  ): Observable<CommonResponseDTO<IPublicKeyResponse>> {
    const url = generateURL({
      endpoint: ENDPOINTS.MAPS_DATA_POINTS_SAVE_GENERATED_PUBLIC_KEY,
      params: { id: mapId },
    });
    return this.http.post<CommonResponseDTO<IPublicKeyResponse>>(url, {
      apiKey,
      reference,
    });
  }

  getGeneratedKey(
    id: string,
    mapId: string
  ): Observable<CommonResponseDTO<IPublicKeyResponse>> {
    const url = generateURL({
      endpoint: ENDPOINTS.MAPS_DATA_POINTS_GET_SPECIFIC_GENERATED_KEY,
      params: { mapId, id },
    });
    return this.http.get<CommonResponseDTO<IPublicKeyResponse>>(url);
  }

  getGeneratedKeys(mapId: string): Observable<CommonResponseDTO<IApiKey[]>> {
    const url = generateURL({
      endpoint: ENDPOINTS.MAPS_DATA_POINTS_GET_ALL_GENERATED_KEYS,
      params: { id: mapId },
    });
    return this.http.get<CommonResponseDTO<IApiKey[]>>(url);
  }

  deleteKey(mapId: string, id: string): Observable<CommonResponseDTO<IApiKey>> {
    const url = generateURL({
      endpoint: ENDPOINTS.MAPS_DATA_POINTS_DELETE_KEY,
      params: { mapId, id },
    });
    return this.http.delete<CommonResponseDTO<IApiKey>>(url);
  }

  restoreKey(
    mapId: string,
    id: string
  ): Observable<CommonResponseDTO<IApiKey>> {
    const url = generateURL({
      endpoint: ENDPOINTS.MAPS_DATA_POINTS_RESTORE_KEY,
      params: { mapId, id },
    });
    return this.http.patch<CommonResponseDTO<IApiKey>>(url, {});
  }
}
